const DeliverySaverPlanComponentDefinition = {
    template: require('./delivery-saver-plan.component.html').trim(),
    bindings: {
        plan: '<',
    },
};

module.exports = {
    DeliverySaverPlanComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/plan/delivery-saver-plan.component.js